"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETelemetryLoggerType = void 0;
var ETelemetryLoggerType;
(function (ETelemetryLoggerType) {
    ETelemetryLoggerType["STDOUT"] = "stdout";
    ETelemetryLoggerType["STATSD"] = "statsd";
})(ETelemetryLoggerType = exports.ETelemetryLoggerType || (exports.ETelemetryLoggerType = {}));
//# sourceMappingURL=types.js.map